module.exports = __webpack_public_path__ + "img/play.5e6c85cd.svg";